import React from "react";
import tw from "twin.macro"; //eslint-disable-line
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/lightBizCode.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import ContactUsForm from "components/forms/ContactUsForm";
import { ReactComponent as ClockIcon } from "feather-icons/dist/icons/clock.svg";
import { ReactComponent as ShieldIcon } from "feather-icons/dist/icons/shield.svg";
import { ReactComponent as CpuIcon } from "feather-icons/dist/icons/cpu.svg";
import { ReactComponent as SmartphoneIcon } from "feather-icons/dist/icons/smartphone.svg";

const WhyUsSection = tw.div`py-16 bg-gray-100`;
const WhyUsInner = tw.div`max-w-screen-xl mx-auto px-8`;
const WhyUsGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6`;
const WhyUsCard = styled.div`${tw`bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center`}`;
const WhyUsIconWrapper = styled.div`
  ${tw`p-3 rounded-full bg-primary-500 text-white mb-4`}
  svg { ${tw`w-6 h-6`} }
`;
const WhyUsTitle = tw.h4`font-bold text-gray-800 mb-2`;
const WhyUsDesc = tw.p`text-gray-600 text-sm leading-relaxed`;

export default () => {

  const whyUs = [
    { Icon: ClockIcon, title: "Respuesta en 24 horas", desc: "Te contactamos rápido para entender tu proyecto y proponerte una solución." },
    { Icon: CpuIcon, title: "Desarrollo a la medida", desc: "ERPs, sitios web, eCommerce y domótica adaptados a tu operación, no plantillas genéricas." },
    { Icon: ShieldIcon, title: "Seguridad primero", desc: "Aplicamos buenas prácticas de seguridad en cada sistema que entregamos." },
    { Icon: SmartphoneIcon, title: "Hardware e instalación", desc: "En productos como accesos o domótica, también vendemos e instalamos el hardware." }
  ];

  const sendMessage = (formData) => {
    const { name, email, subject, message } = formData;
    const text =
      `Nombre: ${name}\nEmail: ${email}\nAsunto: ${subject}\nMensaje: ${message}`;
    const phone = "3325646932";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  return (
    <AnimationRevealPage>
      <Header />
      <ContactUsForm
        subheading="Estamos aquí para ayudarte"
        heading={<>Cuéntanos sobre <span className="text-primary-500">tu proyecto.</span></>}
        description="¿Necesitas controlar el acceso en tu fraccionamiento, escuela o negocio? ¿Quieres un ERP, una tienda en línea o domótica para tu hogar? Escríbenos y te respondemos en menos de 24 horas."
        formAction={sendMessage}
      />
      <WhyUsSection>
        <WhyUsInner>
          <WhyUsGrid>
            {whyUs.map((item, i) => (
              <WhyUsCard key={i}>
                <WhyUsIconWrapper>
                  <item.Icon />
                </WhyUsIconWrapper>
                <WhyUsTitle>{item.title}</WhyUsTitle>
                <WhyUsDesc>{item.desc}</WhyUsDesc>
              </WhyUsCard>
            ))}
          </WhyUsGrid>
        </WhyUsInner>
      </WhyUsSection>
      <Footer />
    </AnimationRevealPage>
  );
};
